import * as React from 'react';
import { TNotFoundFallback } from './NotFoundFallback.types';
import './NotFoundFallback.styled.scss';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';

export const NotFoundFallback: TNotFoundFallback = () => {
  const localize = useLocalize();

  return (
    <div className="not-found-fallback">
      <h1>404</h1>
      <p>{localize('notfound.title')}</p>
    </div>
  );
};
